import { Box, Typography, Button, styled } from "@mui/material";
import { colors } from "../../../theme/colors";

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "40px 48px 36px",
  boxSizing: "border-box",
  textAlign: "center",
});

export const SuccessIcon = styled(Box)({
  width: "64px",
  height: "64px",
  borderRadius: "50%",
  backgroundColor: colors.status.activeBg,
  color: colors.status.activeText,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "20px",
});

export const ModalTitle = styled(Typography)({
  fontFamily: '"Sora", sans-serif',
  fontSize: "20px",
  fontWeight: 700,
  color: colors.text.primary,
  marginBottom: "8px",
});

export const ModalSubtitle = styled(Typography)({
  fontFamily: '"Nunito", sans-serif',
  fontSize: "14px",
  color: colors.text.secondary,
  marginBottom: "24px",
  lineHeight: 1.5,
  "& strong": {
    color: colors.text.primary,
    fontWeight: 700,
  },
});

export const WarningBox = styled(Box)({
  width: "100%",
  backgroundColor: colors.amber.background,
  border: `1px solid ${colors.amber.light}`,
  borderRadius: "8px",
  padding: "16px",
  marginBottom: "28px",
  textAlign: "left",
});

export const WarningTitle = styled(Typography)({
  fontFamily: '"Nunito", sans-serif',
  fontSize: "13px",
  fontWeight: 700,
  color: colors.amber.text,
  marginBottom: "4px",
  display: "flex",
  alignItems: "center",
  gap: "6px",
});

export const WarningText = styled(Typography)({
  fontFamily: '"Nunito", sans-serif',
  fontSize: "13px",
  color: colors.amber.text,
  lineHeight: 1.5,
  marginBottom: "16px",
});

export const KeyRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  backgroundColor: colors.background.secondary,
  border: `1px solid ${colors.border.light}`,
  borderRadius: "8px",
  padding: "10px 14px",
});

export const KeyText = styled(Typography)({
  fontFamily: '"Nunito", sans-serif',
  fontSize: "16px",
  fontWeight: 700,
  color: colors.text.primary,
  letterSpacing: "0.05em",
  flex: 1,
});

export const CopyButton = styled(Button)({
  minWidth: "90px",
  height: "36px",
  backgroundColor: colors.amber.main,
  color: colors.text.white,
  fontFamily: '"Nunito", sans-serif',
  fontSize: "13px",
  fontWeight: 700,
  textTransform: "none",
  borderRadius: "6px",
  boxShadow: "none",
  flexShrink: 0,
  "&:hover": {
    backgroundColor: colors.amber.dark,
    boxShadow: "none",
  },
});

export const DoneButton = styled(Button)({
  minWidth: "120px",
  height: "44px",
  backgroundColor: colors.primary.main,
  color: colors.text.white,
  fontFamily: '"Nunito", sans-serif',
  fontSize: "14px",
  fontWeight: 700,
  textTransform: "none",
  borderRadius: "8px",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: colors.primary.dark,
    boxShadow: "none",
  },
});
